import { useContext } from 'react';
import './style.scss';
import { ReactComponent as UploadPlus } from '../../upload-plus.svg';
import { ReactComponent as UploadX } from '../../upload-x.svg';
import { FormDataContext } from '../FormDataProvider';

function StudyStep() {

  const { updateFormData, formData, handleFileChange, handleFileRemove, handleSingleFormDataChange } = useContext(FormDataContext);

  var projectLectureEducationDisabled = false;

  if (formData['has_exam'] == false && formData['project_lecture_education'] == undefined) {
    handleSingleFormDataChange({'project_lecture_education': false});
  }

  return (
    <div className="study-step">
      <h2>Studieintyg</h2>
      <p className="desc">Vänligen komplettera nedan.</p>
        <form>
            <h3>Kompletterande information</h3>
            <label className="full check">
                {!formData['has_exam'] && <>
                <input type="checkbox" name="project_lecture_education" value="Ja" onChange={(e) => updateFormData(e)} defaultChecked={projectLectureEducationDisabled} disabled={projectLectureEducationDisabled} /><span>Jag ansöker om medlemskap i anslutning till Svenska Tecknares föreläsning på min utbildning.</span>
                </>}
            </label>
            <label className="full">
                Avslutar/avslutade studier år
                <input type="text" name="studies_done_year" placeholder="Skriv i siffror" onChange={(e) => updateFormData(e)} required />
            </label> 
            <label className="full">
                Utbildning
                <input type="text" name="education" placeholder="Utbildning" onChange={(e) => updateFormData(e)} required />
            </label> 
            <label className="full dropdown">
                Utbildningsnivå
                <select name="education_level" onChange={(e) => updateFormData(e)}>
                    <option value="" defaultValue={''} disabled>Välj ...</option>
                    <option value="gymnasium">Gymnasienivå</option>
                    <option value="public_university">Folkhögskoleutbildning</option>
                    <option value="vocational">Yrkesutbildning</option>
                    <option value="candidate">Kandidat</option>
                    <option value="master">Master</option>
                    <option value="doctoral">Doktorand</option>
                </select>
            </label> 
            {formData['project_lecture_education'] != true && <>
                <p>Ladda upp ditt examensbevis eller ditt studieintyg om du har examen från en <a target="_blank" href="/studentmedlemskap/">godkänd utbildning</a>.</p>
                    
                <label className="full">
                    <div className="file-upload">
                        <UploadPlus />
                        <h3>Ladda upp dina filer</h3>
                        <span>Eller välj mapp. pdf, png, jpg eller jpeg. Max 10mb.</span>
                        <input type="file" name="study_certificate_files" multiple accept="application/pdf, image/png, image/jpeg, image/jpg" className="hidden" onChange={(e) => handleFileChange(e)} required />
                    </div>
                </label>
                {formData && formData['study_certificate_files'] != undefined && formData['study_certificate_files'].length && <div className="file-upload-list">
                    <p>Uppladdade filer</p>
                    {formData['study_certificate_files'].map((file, index) => (
                    <div className="file-upload-list-item" key={index}>
                        <div className="file-upload-list-item-file">
                        <span>{file.name}</span>
                        <UploadX name="study_certificate_files" pid={file.material_pid && file.material_pid} onClick={(e) => handleFileRemove(e)} />
                        </div>
                    </div>
                    ))}
                </div>}
              </>}
        </form>
    </div>
  );
}

export default StudyStep;
